import React from "react";
import { ComponentDetailsByFileOut } from "api-client";
import {
  FIELDSSET_TITLE_CLASSES,
  FIELD_LABEL_CLASSES,
  FIELD_VALUE_CLASSES,
} from "features/MappingEditor/consts";
import { getCurrentReferenceUnitValue } from "features/MappingEditor/utils";
import { useTranslation } from "react-i18next";

const ReferenceUnit = ({
  details,
}: {
  details: ComponentDetailsByFileOut | undefined;
}) => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const referenceUnit = getCurrentReferenceUnitValue(
    details?.reference_unit.toUpperCase()
  );

  return (
    <div className="pt-4">
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("mapping.referenceUnitAndEnvironmentalData")}
      </div>
      <div className={FIELD_LABEL_CLASSES}>{t("mapping.referenceUnit")}</div>
      <div className={FIELD_VALUE_CLASSES}>
        {isEng ? referenceUnit?.name ?? "-" : referenceUnit?.name_de ?? "-"}
      </div>
    </div>
  );
};

export default ReferenceUnit;
